import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { notBlank } from "../util/ext";

const ReadOnlyField = ({ children, ...props }) => {
  const [value, setValue] = useState();
  useEffect(() => {
    const val = notBlank(children) ? children : "--";
    setValue(val);
  }, [children]);

  return (
    <Typography style={{ whiteSpace: "pre-wrap" }} {...props}>
      {value}
    </Typography>
  );
};

export default ReadOnlyField;
